import { render, staticRenderFns } from "./DayCard.vue?vue&type=template&id=349a6587"
import script from "./DayCard.vue?vue&type=script&lang=ts"
export * from "./DayCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports